/* =========================
   VG PAYMENT POPUP FINAL
========================= */

document.addEventListener('DOMContentLoaded', function(){

  const popup =
    document.getElementById('vgPaymentPopup');

  const closeBtn =
    document.getElementById('vgPaymentClose');

  const submitBtn =
    document.getElementById('vgPaymentSubmit');

  if(!popup) return;

  /* OPEN POPUP */

  document.body.addEventListener('click', function(e){

    const btn = e.target.closest(
      '.vg-checkout-btn, button[name="checkout"], a[href="/checkout"]'
    );

    if(!btn) return;

    e.preventDefault();

    popup.classList.add('active');

    document.body.classList.add('vg-lock');

  });

  /* CLOSE POPUP */

  if(closeBtn){

    closeBtn.addEventListener('click', function(){

      popup.classList.remove('active');

      document.body.classList.remove('vg-lock');

    });

  }

  /* OVERLAY CLOSE */

  const overlay =
    popup.querySelector('.vg-payment-overlay');

  if(overlay){

    overlay.addEventListener('click', function(){

      popup.classList.remove('active');

      document.body.classList.remove('vg-lock');

    });

  }

  /* OPTION SELECT */

  const cards =
    popup.querySelectorAll('.vg-pay-card');

  cards.forEach(card => {

    card.addEventListener('click', function(){

      cards.forEach(el =>
        el.classList.remove('active')
      );

      card.classList.add('active');

      card.querySelector('input').checked = true;

    });

  });

  /* CHECKOUT */

  if(submitBtn){

    submitBtn.addEventListener('click', function(){

      window.location.href = '/checkout';

    });

  }

});

